package org.moxultimate.topwithmox.libraries.sample

import kotlinx.coroutines.delay
import kotlin.time.Duration.Companion.milliseconds

/**
 * Contract for the greeting data source.
 * Defining an interface allows Koin to swap implementations
 * (e.g., real vs. fake) without touching call sites.
 */
interface GreetingRepository {
    /** Returns a greeting message for [name]. Suspends to simulate async work. */
    suspend fun greet(name: String): String
}

/**
 * Production implementation of [GreetingRepository].
 * Registered as a `single` in [org.moxultimate.topwithmox.di.SampleModule].
 */
class GreetingRepositoryImpl : GreetingRepository {
    override suspend fun greet(name: String): String {
        delay(400.milliseconds)   // simulate network latency
        return "Hello, $name! 👋 (from Koin-injected repository)"
    }
}
